import { Slider } from "@material-ui/core";
import useWindowDimensions from "helpers/screen";
import "./style.scss";
import {ReactComponent as InfoIcon} from "assets/icons/info.svg";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import { useEffect, useState } from "react";
import { countDecimals, formatNumber, GetTokenBalance, GetTokenData, tickLength } from "helpers/helpers";
import { getDecimalCount, placeOrder } from "utils/order";
import { PublicKey } from "@solana/web3.js";
import toast from 'react-hot-toast';
import { fetchUserAccounts } from "ts/accountInfo/tokens";
import { fetchOpenOrders } from "ts/accountInfo/openOrders";
import { accounts, appendQueue, setOpenOrders } from "redux/state";
import { useDispatch, useSelector } from "react-redux";

const OrderBox = ({marketData, arrangement, limitPrice, setLimitPrice, tradeAmount, setTradeAmount, totalAmount, setTotalAmount}) => {
  const {width} = useWindowDimensions();
  const state = useSelector((state) => state.storage);
  const dispatch = useDispatch();
  const [baseTokenInfo, setBaseTokenInfo] = useState();
  const [quoteTokenInfo, setQuoteTokenInfo] = useState();

  // Order info
  const [orderType, setOrderType] = useState("limit");
  const [orderSide, setOrderSide] = useState("buy");

  const [quoteAmount, setQuoteAmount] = useState();
  const [maxBaseAmount, setMaxBaseAmount] = useState();
  const [maxQuoteAmount, setMaxQuoteAmount] = useState();
  const [sliderPercentage, setSliderPercentage] = useState(0);

  const [orderStatus, setOrderStatus] = useState(null); 
  const [snack, setSnack] = useState(false)

  const [maxTickSize, setMaxTickSize] = useState(6);

  function setTradeSize(amount) {
    let processedAmount = amount;
    if(countDecimals(processedAmount) > tickLength(maxTickSize)) processedAmount = parseFloat(processedAmount).toFixed(tickLength(maxTickSize));
    processedAmount = processedAmount.toString().replace(/,/g, '.') 
    setTradeAmount(processedAmount);
  }
  function makeOrder() {
    if(orderType === "limit" && !limitPrice) {
      toast.error("Please enter limit price!");
      return;
    }
    let toastId = toast.loading("Please approve transaction in your wallet");
    let formattedTickSize =
        marketData.serumMarket.tickSize?.toFixed(getDecimalCount(marketData.serumMarket.tickSize)) ||
        marketData.serumMarket.tickSize;
    let price = limitPrice ? limitPrice : formattedTickSize;
      try{
        placeOrder({
          side:orderSide,
          price: price,
          size: tradeAmount,
          orderType: orderType === "limit" ? "limit" : "ioc",
          market: marketData.serumMarket,
          connection: state.connection,
          wallet: state.wallet,
          baseCurrencyAccount: baseTokenInfo.associatedAddress ? new PublicKey(baseTokenInfo.associatedAddress) : null,
          quoteCurrencyAccount: quoteTokenInfo.associatedAddress ? new PublicKey(quoteTokenInfo.associatedAddress) : null,
          feeDiscountPubkey: undefined,
          toastId: toastId
        }).catch((e) => {
          setOrderStatus({ message: "" + e, type: 'error' })
          toast.error(`Transaction cancelled!`, {
            id: toastId,
          });
          return;
        }).then((res) => {
          Promise.all([
            fetchUserAccounts(state),
            fetchOpenOrders(state),
          ]).then(res => {
            dispatch(accounts(res[0]));
            dispatch(setOpenOrders(res[1]));
          })
          if(res){
            dispatch(appendQueue({type:"order", id:Math.floor(Math.random() * 10000000)}))
            setOrderStatus({ message: "" + res, type: 'done' })
          }
        })
      }catch(err){
        toast.error(`Something went wrong!`, {
          id: toastId,
        });
        console.log("ERR", err)
      }
  }


  function balance(tokenInfo) {
    let balance = tokenInfo.balance;
    if (tokenInfo.symbol == "SOL" || tokenInfo.symbol == "wSOL")
      balance -= 0.03;
    if (balance < 0) balance = 0;
    return balance;
  }

  useEffect(() => {
    setQuoteAmount(parseFloat((limitPrice * tradeAmount).toFixed(6)))
  }, [tradeAmount])

  useEffect(() => { // Sets minimum trade size increment
    if(marketData.serumMarket) {
      let formattedMinOrderSize =
      marketData.serumMarket?.minOrderSize?.toFixed(getDecimalCount(marketData.serumMarket.minOrderSize)) ||
      marketData.serumMarket?.minOrderSize;
      setMaxTickSize(formattedMinOrderSize);
    } 
  },[marketData]);

  useEffect(() => { // slider
    // if(maxBaseAmount && maxQuoteAmount) {
      let newTradeAmount = (maxBaseAmount * sliderPercentage / 100);
      let pow = tickLength(maxTickSize);
      newTradeAmount = Math.floor(newTradeAmount * 10 ** pow) / (10 ** pow);
      setTradeAmount(newTradeAmount, sliderPercentage);
    // }
  }, [sliderPercentage, maxBaseAmount, maxQuoteAmount, orderType]);

  useEffect(() => { // Base Amount MAX
    if(!baseTokenInfo || !quoteTokenInfo || !marketData.orderbook)
      return;
    
    let maxAmount = 0;
    if(orderSide === "buy") {
      if(orderType === "limit")
        maxAmount = balance(quoteTokenInfo) / parseFloat(limitPrice ? limitPrice : 0.0001);
      else if(orderType === "market")
        maxAmount = balance(quoteTokenInfo);
    } else
      maxAmount = balance(baseTokenInfo);
    setMaxBaseAmount(parseFloat(maxAmount));
  }, [baseTokenInfo, quoteTokenInfo, marketData.orderbook, orderType, orderSide, limitPrice])
  
  useEffect(() => { // QuoteAmount MAX
    if(!baseTokenInfo || !quoteTokenInfo || !marketData.orderbook)
      return;
    
    let maxAmount = 0;
    if(orderSide === "buy")
      maxAmount = quoteTokenInfo.balance;
    else {
      if(orderType === "limit")
        maxAmount = quoteTokenInfo.balance / parseFloat(limitPrice ? limitPrice : 0.0001);
      else if(orderType === "market")
        maxAmount = baseTokenInfo.balance * marketData.orderbook.bids[0][0]
    }
    setMaxQuoteAmount(parseFloat(maxAmount));
  }, [baseTokenInfo, quoteTokenInfo, marketData.orderbook, orderType, orderSide, limitPrice]);



  useEffect(() => {
    if(state.tokenList && marketData.pairs && state.accounts.length > 0) {
      let baseToken = GetTokenData(marketData.pairs.base.symbol, state.tokenList);
      let baseTokenInfo = GetTokenBalance(baseToken.address, state.accounts);
      console.log("bbbbb", baseToken, baseTokenInfo)
      baseToken.balance = baseTokenInfo.balance;
      baseToken.associatedAddress = baseTokenInfo.address;
      let quoteToken = GetTokenData(marketData.pairs.quote.symbol, state.tokenList);
      let quoteTokenInfo = GetTokenBalance(quoteToken.address, state.accounts);
      quoteToken.balance = quoteTokenInfo.balance;
      quoteToken.associatedAddress = quoteTokenInfo.address;
      setBaseTokenInfo(baseToken);
      setQuoteTokenInfo(quoteToken);
    }
  },[state.tokenList, marketData.pairs, state.accounts]);

  if(width > 768)
  return <div className="orderBoxWrapper" style={arrangement > 0 ? {borderLeft:"1px solid var(--gray0)"} : {borderRight:"1px solid var(--gray0)"} }>
    <div className="balancesWrapper">
      {/* <div className="item">
        <p className="title">Balances</p>
        <Link to={"/wallet"} className=""><p className="primaryButton">Manage</p></Link>
      </div> */}
      <div className="item">
        <p className="title">{baseTokenInfo && baseTokenInfo.name}</p>
        <p className="title">{baseTokenInfo && formatNumber(baseTokenInfo.balance,6)} {marketData.pairs && marketData.pairs.base.symbol}</p>
      </div>
      <div className="item">
        <p className="title">{quoteTokenInfo && quoteTokenInfo.name}</p>
        <p className="title">{quoteTokenInfo && formatNumber(quoteTokenInfo.balance,6)} {marketData.pairs && marketData.pairs.quote.symbol}</p>
      </div>
      {/* <div className="item">
        <p className="title">Margin</p>
        <p className="title disabled">Disabled</p>
      </div> */}
    </div>

    <div className="orderBox">
      <div className="orderType disable-select">
        <div className={orderType === "limit" ? "orderTypeButton selected" : "orderTypeButton"} onClick=
          {() => { setOrderType("limit"); if (orderType !== "limit") { setQuoteAmount(); setTradeAmount("");} }}>
          Limit
        </div>
        <div className={orderType === "market" ? "orderTypeButton selected" : "orderTypeButton"} onClick=
          {() => { setOrderType("market"); if (orderType !== "market") { setQuoteAmount(); setTradeAmount("");} }}>
          Market
        </div>
      </div>

      <div className="orderInputs">
        <div className="orderSide disable-select">
          <div className={orderSide === "buy" ? "buySide" : "buySide inactive"} onClick=
            {() => { setOrderSide("buy"); if (orderSide !== "buy") { setQuoteAmount(); setTradeAmount("");} }}>
            {
              orderSide === "buy" ?
              <p className="side active">Buy</p>
              :
              <p className="side">Buy</p>
            }
          </div>
          <div className={orderSide === "sell" ? "sellSide" : "sellSide inactive"} onClick=
            {() => { setOrderSide("sell"); if (orderSide !== "sell") { setQuoteAmount(); setTradeAmount("");} }}>
          {
              orderSide === "sell" ?
              <p className="side active">Sell</p>
              :
              <p className="side">Sell</p>
            }
          </div>
        </div>

        <div className="inputField">
          <div className="label">
            <p className="labelTitle">Limit Price</p>
            <p className="tickerWrapper">{quoteTokenInfo && quoteTokenInfo.symbol}</p>
          </div>
          { orderType === "limit" ?
            <input type={"number"} disabled={orderType === "market"} value={orderType === "market" ? "MARKET" : limitPrice} onChange={(e) => {
              setLimitPrice(e.target.value)
            }} placeholder="0.00"/>
            :
            <input disabled value={""} placeholder="MARKET"/>
          } 
        </div>

        <div className="doubleInputField">
          <div className="label">
            <p className="labelTitle">Amount</p>
            <p className="labelInfo">Set order size</p>
          </div>
          <div className="inputs">
            <div className="inputWrapper" style={{marginRight:0, width:"100%"}}>
              <input 
                placeholder="0.00"
                min={0}
                value={tradeAmount}
                type={"number"}
                onChange={(e) => parseFloat(e.target.value) > maxBaseAmount ? setTradeSize(maxBaseAmount) : setTradeSize(e.target.value)}
              />
              <p className="tickerWrapper">
              {(orderType == "market" && orderSide == "buy") ?
                (quoteTokenInfo && quoteTokenInfo.symbol) :
                (baseTokenInfo && baseTokenInfo.symbol)
              } 
              </p>
            </div>
          </div>
        </div>
        
        
        <Slider
          defaultValue={0}
          aria-labelledby="Order Size"
          step={5}
          marks={[
            {
              value: 0,
            },
            {
              value: 25,
            },
            {
              value: 50,
            },
            {
              value: 75,
            },
            {
              value: 100,
            }
          ]}
          min={0}
          max={100}
          className="orderSlider"
          value={Math.floor((tradeAmount / maxBaseAmount) * 100)}
          onChange={(e, v) => {
            setSliderPercentage(v)
              // if(v !== sliderPercentage) {
                // if(orderType === "limit" && limitPrice)
                //   setSliderPercentage(v)
                // else if(orderType === "market")
                //   setSliderPercentage(v)
              // }
            }
          }
        />
        <div className="sliderButtons justify-between disable-select">
          <div className="sliderButton" onClick={() => setSliderPercentage(0)}>
            0%
          </div>
          <div className="sliderButton" onClick={() => setSliderPercentage(50)}>
            HALF
          </div>
          <div className="sliderButton" onClick={() => setSliderPercentage(100)}>
            MAX
          </div>
        </div>
      </div>
          
      <div className="placeOrder">
        <div className="orderDetails">
          <div className="justify-between">
            <p className="title">Total Cost</p>
            <p className="value">
              {
                (quoteAmount && quoteTokenInfo && quoteAmount > 0) ?
                  orderType === "limit" ?
                    quoteAmount + " " + quoteTokenInfo.symbol
                    :
                    tradeAmount + " " + quoteTokenInfo.symbol
                  :
                  "-"
              }
            </p>
          </div>
          {/* <div className="justify-between">
            <p className="title">Price Impact</p>
            <p className="value">-</p>
          </div> */}
          <div className="justify-between">
            <div className="title flex">Fee<p style={{marginLeft:"0.5rem"}} className="tickerWrapper">Taker</p></div>
            <p className="value">-</p>
          </div>
          {/* <div className="justify-between">
            <p className="title">Expected Price</p>
            <p className="value">-</p>
          </div> */}
        </div>
        { 
          tradeAmount > 0 && tradeAmount <= maxBaseAmount &&
            <div className="orderButton orderButtonActive" onClick={() => makeOrder()}>
              Place Order
            </div>
        }
        { 
          tradeAmount > maxBaseAmount &&
            <div className="orderButton">
              Not enough balance
            </div>
        }
        { 
          (!tradeAmount || tradeAmount == 0) &&
            <div className="orderButton">
              Enter amount
            </div>
        }
      </div>
      

    </div>
  </div>

if(width <= 768) // mobile view
return <div className="orderBoxWrapperMobile">

  <div className="orderBox">
    <div className="orderSide">
      <div className={orderSide === "buy" ? "orderSideButton buyButton" : "orderSideButton"} onClick={() => setOrderSide("buy")}>
        Buy
      </div>
      <div className={orderSide === "sell" ? "orderSideButton sellButton" : "orderSideButton"} onClick={() => setOrderSide("sell")}>
        Sell
      </div>
    </div>

    <div className="orderInputs">
      
      
      <Dropdown className="orderType" controlClassName='orderType' options={[
        <div className="flex"><InfoIcon fill={"var(--gray500)"}/> <p style={{marginLeft:"0.5rem"}}>Limit Order</p></div>,
        <div className="flex"><InfoIcon fill={"var(--gray500)"}/> <p style={{marginLeft:"0.5rem"}}>Market Order</p></div>
      ]} onChange={(e) => { console.log("AAAA", e)
        if(e.value.props.children[2].props.children === "Market Order") 
          setOrderType("market")
        else 
          setOrderType("limit")
        }
        } value={"Limit Order"} placeholder="Order Type" />
      <div className="inputFieldMobile">
        { orderType === "limit" ?
          <input type={"number"} disabled={orderType === "market"} value={orderType === "market" ? "MARKET" : limitPrice} onChange={(e) => {
            setLimitPrice(e.target.value)
          }} placeholder="Limit Price"/>
          :
          <input disabled value={""} placeholder="MARKET"/>
        } 
      </div>
      
      <div className="inputFieldMobile">
        <input 
          placeholder={
            orderType === "limit" ? "Amount (Base)"
            :
            "Amount (Quote)"
          }
          min={0}
          value={tradeAmount}
          type={"number"}
          onChange={(e) => parseFloat(e.target.value) > maxBaseAmount ? setTradeSize(maxBaseAmount) : setTradeSize(e.target.value)}
        />
      </div>

      <Slider
          defaultValue={0}
          aria-labelledby="Order Size"
          step={5}
          marks={[
            {
              value: 0,
            },
            {
              value: 25,
            },
            {
              value: 50,
            },
            {
              value: 75,
            },
            {
              value: 100,
            }
          ]}
          min={0}
          max={100}
          className="orderSliderMobile"
          value={Math.floor((tradeAmount / maxBaseAmount) * 100)}
          onChange={(e, v) => {
              if(v !== sliderPercentage) {
                if(orderType === "limit" && limitPrice)
                  setSliderPercentage(v)
                else if(orderType === "market")
                  setSliderPercentage(v)
              }
            }
          }
        />

      { orderType === "limit" &&
        <div className="inputFieldMobile">
        <input placeholder={"Total"}value={(quoteAmount && quoteTokenInfo && quoteAmount > 0) ?
          quoteAmount + " " + quoteTokenInfo.symbol
          :
          ""} disabled/>
      </div>
      }
    </div>

    
    <div className="bottomSection">
      <div className="justify-between">
        <p>Available Balance:</p>
        {
          orderSide === "buy" ?
          <p>{quoteTokenInfo && quoteTokenInfo.balance} {quoteTokenInfo && quoteTokenInfo.symbol}</p>
          :
          <p>{baseTokenInfo && baseTokenInfo.balance} {baseTokenInfo && baseTokenInfo.symbol}</p>

        }
      </div>
      { 
        tradeAmount > 0 && tradeAmount <= maxBaseAmount &&
          <div className="orderButton orderButtonActive" onClick={() => makeOrder()}>
            {
              orderSide === "buy" ?
              "Buy " + baseTokenInfo.symbol
              :
              "Sell " + baseTokenInfo.symbol
            }
          </div>
      }
      { 
        tradeAmount > maxBaseAmount &&
          <div className="orderButton">
            Not enough balance
          </div>
      }
      { 
        (!tradeAmount || tradeAmount == 0) &&
          <div className="orderButton">
            Enter amount
          </div>
      }
    </div>
    

  </div>

</div>
}

export default OrderBox;
